import lazyScreen from '../utils/lazyScreen';
const LGOrder = lazyScreen(() => import('../pages/lg/LGOrder/index.js'), 'pages/lg/LGOrder/index.js');
const LGOrders = lazyScreen(() => import('../pages/lg/LGOrders/index.js'), 'pages/lg/LGOrders/index.js');
const LGTransport = lazyScreen(() => import('../pages/lg/LGTransport/index.js'), 'pages/lg/LGTransport/index.js');
const LGTransports = lazyScreen(() => import('../pages/lg/LGTransports/index.js'), 'pages/lg/LGTransports/index.js');
const LGLog = lazyScreen(() => import('../pages/lg/LGLog/index.js'), 'pages/lg/LGLog/index.js');
const LGLogs = lazyScreen(() => import('../pages/lg/LGLogs/index.js'), 'pages/lg/LGLogs/index.js');

export default [
    {
        path: '/lg/LGOrders',
        component: LGOrders
    },
    {
        path: '/lg/LGOrder/:code',
        component: LGOrder
    },
    {
        path: '/lg/LGTransports',
        component: LGTransports
    },
    {
        path: '/lg/LGTransport/:code',
        component: LGTransport
    },
    {
        path: '/lg/LGLogs',
        component: LGLogs
    },
    {
        path: '/lg/LGLog/:id',
        component: LGLog
    }
];
